import { useSelector } from 'react-redux';

import { userAccountIdSelector } from 'selectors/user/user-features-selector';

import { canSyncHeaderPins } from '../../header-pins';
import type { HeaderPinsUserId } from '../../header-pins';
import { useLauncherItemsSync } from '../../hooks/use-launcher-items-sync';

interface UserLauncherItemsSyncProps {
    userId: number;
}

const UserLauncherItemsSync = ({ userId }: UserLauncherItemsSyncProps) => {
    useLauncherItemsSync({ userId });

    return null;
};

/** Keeps the header pins of the signed-in user in sync with the backend; renders nothing */
const LauncherItemsSync = () => {
    const userId: HeaderPinsUserId = useSelector(userAccountIdSelector);

    // Another user (re-login, an admin in a client's session) starts again: their items are loaded anew
    return canSyncHeaderPins(userId) ? <UserLauncherItemsSync key={userId} userId={userId} /> : null;
};

export default LauncherItemsSync;
